import GlobalData from "@/GlobalData";
import { api, client } from "@/client";
import { useAuthenticationStore } from "@/stores/authentication";
import { defineStore, acceptHMRUpdate } from "pinia";
import { useRouter } from "vue-router";
import { LogarithmicScale } from "chart.js";

export const useDIPStore = defineStore("dip", {
  state: () => ({
    currentDip: {},
    dip: [] as Array<api.DIP>,
    totalRecords: 0 as Number,
    loading: false,
    currentFilters: [
      { fieldName: "transfer_number", filterText: "" },
      { fieldName: "transferring_agency", filterText: "" },
      {
        fieldName: "transfer_date",
        filterText: "",
      },
      { fieldName: "security_grading", filterText: "" },
      { fieldName: "sensivity_classification", filterText: "" },
      { fieldName: "dip_uuid", filterText: "" },
    ] as Array<any>,
    currentPage: 1 as Number,
    currentPerPage: 20 as any,
    multidownloaddipnumber: 0 as any,
    errorIdArray: [] as Array<any>,
  }),
  getters: {},
  actions: {
    async fetchDip(filters: Array<any>) {
      this.currentFilters = filters;
      this.loading = true;
      client.content
        .contentsListDips({
          transferBatchNumber: filters[0].filterText,
          transferringAgency: filters[1].filterText,
          transferDate: filters[2].filterText,
          securityGrading: filters[3].filterText,
          sensitivityClassification: filters[4].filterText,
          id: filters[5].filterText,
          limit: 1000,
        })
        .then((payload) => {
          this.currentDip = payload.items;
          this.totalRecords = payload.totalCount;
          // this.currentStartingAfter = String(payload.items[0].id + 1);
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          //this.loading = false;
          return error;
        });
    },

    async downloadDip(
      transferId: string,
      packageId: string,
      securityGrading: string
    ) {
      this.loading = true;
 
      client.content.contentsDownloadTransferPackageRaw({ id: transferId, packageId: packageId })
        .then((res) => res.raw)
        .then((res) => {
         

          // Proceed with handling the Response
          if (res.status <= 299) {
            return res.blob().then((blob) => ({ blob, res }));
          } 
          else if (res.status === 404) {
            alert("The DIP (" + packageId + ") is more than 7 days old and has been removed.");
            throw new Error("Package not found");
          } else {
            alert("Error Code " + res.status + ". Please inform FM.");
            throw new Error("Failed to download package");
          }
        })
        .then(({ blob, res }) => {
          const fileName = securityGrading === "Secret" ? "[SECRET]" + packageId : packageId;
          downloadBlob(blob, fileName + ".zip");
        })
        .catch((error) => {
          console.error("Error downloading transfer package:", error);
          
           if  ( error.response.status === 404) {
            alert("The DIP (" + packageId + ") is more than 7 days and has been removed.");
            throw new Error("Package not found");
          } else {
            alert("Error Code " +  error.response.status + ". Please inform FM.");
            throw new Error("Failed to download package");
          }


        })
        .finally(() => {
          this.loading = false;
        });

      function downloadBlob(blob, fileName) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }

      // fetch(
      //   import.meta.env.VITE_SERVER_HOST +
      //     "/contents/transfers/" +
      //     transferId +
      //     "/packages/" +
      //     packageId +
      //     "/download",
      //   {
      //     headers: {
      //       Authorization: "" + useAuthenticationStore().user?.access_token,
      //     },
      //   }
      // )
      //   .then((res) => {
      //     if (res.status <= 299) {
      //       res.blob().then((blob) => {
      //         if (securityGrading == "Secret") {
      //           const url = window.URL.createObjectURL(blob);
      //           const a = document.createElement("a");
      //           a.href = url;
      //           a.download = "[SECRET]" + packageId + ".zip";
      //           document.body.appendChild(a);
      //           a.click();
      //           window.URL.revokeObjectURL(url);
      //         } else {
      //           const url = window.URL.createObjectURL(blob);
      //           const a = document.createElement("a");
      //           a.href = url;
      //           a.download = packageId + ".zip";
      //           document.body.appendChild(a);
      //           a.click();
      //           window.URL.revokeObjectURL(url);
      //         }
      //       });
      //     } else if (res.status == 404) {
      //       alert("The DIP ("+ packageId +") is more than 7 days and have been removed.");
      //     } else{
      //       alert("Error Code"+res.status+"Please Inform FM.");
      //     }       
      //   })
      //   .finally(()=> {
      //     this.loading = false;
      //   })
      //   .catch((error) => {
      //     return error;
      //   });
    },

    async downloadMultiDip(
      transferId: string,
      packageId: string,
      securityGrading: string
    ) {

      client.content.contentsDownloadTransferPackageRaw({ id: transferId, packageId: packageId })
      .then((res) => res.raw)
        .then((res) => {
          // Check if res is a Response object
          if (!(res instanceof Response)) {
            throw new Error("Invalid response: Expected a Response object");
          }

          // Proceed with handling the Response
          if (res.status <= 299) {
            return res.blob().then((blob) => ({ blob, res }));
          } else if (res.status === 404) {
            alert("The DIP (" + packageId + ") is more than 7 days old and has been removed.");
          } else {
            alert("Error Code " + res.status + ". Please inform FM.");
          }
        })
        .then((result) => {
          if (!result) return; // Handle the case where result is undefined
          const { blob, res } = result; // Destructure the result object
          const fileName = securityGrading === "Secret" ? "[SECRET]" + packageId : packageId;
          downloadBlob(blob, fileName + ".zip");
        })
        .catch((error) => {
          console.error("Error downloading transfer package:", error);
          if ( error.response.status === 404) {
            this.errorIdArray.push(packageId);
          } 
        })
        .finally(() => {
          this.multidownloaddipnumber += 1;
          this.loading = false;
        });

      function downloadBlob(blob, fileName) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }


      // fetch(
      //   import.meta.env.VITE_SERVER_HOST +
      //     "/contents/transfers/" +
      //     transferId +
      //     "/packages/" +
      //     packageId +
      //     "/download",
      //   {
      //     headers: {
      //       Authorization: "" + useAuthenticationStore().user?.access_token,
      //     },
      //   }
      // )
      //   .then((res) => {
      //     if (res.status <= 299) {
      //       res.blob().then((blob) => {
      //         if (securityGrading == "Secret") {
      //           const url = window.URL.createObjectURL(blob);
      //           const a = document.createElement("a");
      //           a.href = url;
      //           a.download = "[SECRET]" + packageId + ".zip";
      //           document.body.appendChild(a);
      //           a.click();
      //           window.URL.revokeObjectURL(url);
      //         } else {
      //           const url = window.URL.createObjectURL(blob);
      //           const a = document.createElement("a");
      //           a.href = url;
      //           a.download = packageId + ".zip";
      //           document.body.appendChild(a);
      //           a.click();
      //           window.URL.revokeObjectURL(url);
      //         }
      //       });
      //     } else if (res.status == 404) {
      //       alert("The DIP ("+ packageId +") is more than 7 days and have been removed.");
      //     } else{
      //       alert("Error Code"+res.status+"Please Inform FM.");
      //     }    
      //    this.multidownloaddipnumber=this.multidownloaddipnumber+1;
      //    this.loading = true;   
      //   })
      //   .catch((error) => {
      //     return error;
      //   });
    },

    async updateDownloadDipNumber(){
      this.multidownloaddipnumber=0;
      this.errorIdArray = [];
      this.loading = false;
    }
  },
});
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDIPStore, import.meta.hot));
}
